import { render, staticRenderFns } from "./info-section.vue?vue&type=template&id=e225b456&"
import script from "./info-section.vue?vue&type=script&lang=js&"
export * from "./info-section.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports